import * as React from 'react';
import { FlexStyledGrid, StyledPagination } from './PaginationFooter.styles';
/**
 * Add a description for your component here
 */
export const PaginationFooter = (props) => {
    return (React.createElement(FlexStyledGrid, null,
        React.createElement(StyledPagination, { count: props?.paginationInfo?.pages, page: props?.paginationInfo?.current, onChange: props.onChange, variant: "outlined" })));
};
PaginationFooter.defaultProps = {};
export default PaginationFooter;
